import { ParagraphNode, StoryNode, TextNode } from '@jg/rich-story';
import { ICampaignData } from '../types/state.d';

type TextOnlyParagraph = { type: 'paragraph'; nodes: TextNode[] };

export const isPlainTextCompatible = (
  storyNodes: StoryNode[],
): storyNodes is TextOnlyParagraph[] =>
  storyNodes &&
  storyNodes.every(
    storyNode =>
      storyNode.type === 'paragraph' &&
      storyNode.nodes.every(paragraphNode => paragraphNode.type === 'text'),
  );

const paragraphNodeToString = (p: TextOnlyParagraph): string =>
  p.nodes
    .map(textNode => textNode.ranges.map(textRange => textRange.text).join(''))
    .join('');

export const richStoryToPlainText = (storyNodes: StoryNode[]): null | string =>
  isPlainTextCompatible(storyNodes)
    ? storyNodes.map(paragraphNodeToString).join('\n\n')
    : null;

export const plainTextToRichStory = (text: string): ParagraphNode[] =>
  text.split('\n\n').map(
    (t: string): ParagraphNode => ({
      type: 'paragraph',
      nodes: [{ type: 'text', ranges: [{ text: t }] }],
    }),
  );

export const transformRichTextToFRPSummaryDto = (
  summary: ICampaignData['summary'],
) => {
  const pageStory = summary ? JSON.parse(summary) : [];
  return richStoryToPlainText(pageStory) || '';
};
